import ToolTipPortal from "components/ToolTipPortal/ToolTipPortal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectState } from "../inputSlice";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { IOutputListItem } from "Dashboard/scenes/ConcreteBase/domain/IOutputListItem";

const initialState = {
  isOpen: false,
  top: 0,
  left: 0,
};

const BottomSection = () => {
  const [tooltip, setTooltip] = useState(initialState);
  const { inputs, selectedIndex } = useSelector(selectState);
  const [outputs, setOutputs] = useState<IOutputListItem[]>([]);

  const close = () => {
    setTooltip(initialState);
  };

  useEffect(() => {
    const abortCtrl = new AbortController();

    const FetchData = async () => {
      try {
        if (selectedIndex !== -1) {
          let result = await concreteBaseService.getOutputs({
            inputId: inputs[selectedIndex].inputId,
          }, { fetchMode: "replace" }, abortCtrl.signal);
          setOutputs(result.listItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    FetchData();
  }, [selectedIndex]);

  return (
    <div className="lager-bottom-section">
      <div className="box-wrapper new-container">
        <div className="box-a">
          <div className="g-grid g-header">
            <div className="row">
              <div className="col lowercase center separator-line">
                <span>br. otpr-rač</span>
              </div>
              <div className="col lowercase separator-line">
                <span>gde je otišlo</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>količina iz.</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>cena izdatog</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>datum izlaza</span>
              </div>
              <div className="col lowercase">
                <span>napomena</span>
                {/* TODO: CHECK PURPOSE OF THIS DROPDOWN AND IMPLEMENT IT IF NEEDED */}
                {/* <select className="drop-menu">
                  <option></option>
                </select> */}
              </div>
            </div>
          </div>

          <div className="g-grid g-content">
            {outputs.length > 0 &&
              outputs.map((output, outputIndex) =>
                <div className="row" key={outputIndex}>
                  <div className="col">
                    <div className="bg-item center">
                      <InfoTooltip tooltip={`${output.billOfLandingId}`} element="span" classesProp=" light">
                        {output.billOfLandingId}
                      </InfoTooltip>
                    </div>
                  </div>
                  <div className="col uppercase strong">
                    <InfoTooltip tooltip={`${output.whereWentToForReal} (na otpremnici: ${output.whereWentToOnBill})`}
                      classesProp={`bg-item${output.whereWentToForReal !== output.whereWentToOnBill ? ' projectOverrideFirst' : ''}`}>
                      <span>{output.whereWentToOnBill}</span>
                    </InfoTooltip>
                  </div>
                  <div className="col strong">
                    <div className="bg-item right ">
                      <span className="danger">
                        {FormatNumber(output.quantity)}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="bg-item right">
                      <span>
                        {FormatNumberWithUnitOrNull(output.totalCost, 'rsd')}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="bg-item center">
                      <span className="light">
                        {FormatDateShort(output.dateOfOutput)}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="bg-item">
                      <span>{output.note}</span>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        <div className="box-b">
          <div className="g-grid g-header">
            <div className="row">
              <div className="col">
                <span className="no-content">0</span>
                <select className="drop-menu">
                  <option></option>
                </select>
              </div>
            </div>
          </div>

          <div className="g-grid g-content" onScroll={() => close()}></div>
        </div>
      </div>
      <ToolTipPortal
        {...tooltip}
        onClose={close}
        text="Napomena"
        offset={{ top: -52, left: 10 }}
      >
        <textarea onKeyDown={() => { }}>Testni tooltip</textarea>
      </ToolTipPortal>
    </div>
  );
};

export default BottomSection;
